/**
 * Format a patient's current state for clinician-facing display.
 *
 * Known state → `"Currently in California"`.
 * Missing state → `"Location unknown"` (no `Currently in` prefix, since that
 * phrasing only makes sense when the state is actually present).
 */
export function formatPatientLocationLabel(state: string | null): string {
  if (state === null) {
    return 'Location unknown';
  }
  return `Currently in ${state}`;
}
